//build event chain to check when landing is powered up
import { callApi } from "../api";
import { getDisclaimerTextColor, getDiscountWithClearanceBadgePrefixText, getStyle } from "../utils";
import SearchParams from "./SearchParams";
import { keyExistQueries, getLimitPageSize, getPageSize, isPagePLB, enablePromoImage, addPromoImage, enableVisitorGroupDiscount, showColor, presetFilterServices } from "./utils";

klevu.coreEvent.build({
    name: "setRemoteConfigLanding",
    fire: function () {
        if (!klevu.getSetting(klevu.settings, "settings.localSettings", false) ||
            klevu.isUndefined(klevu.search.landing)) {
            return false;
        }
        return true;
    },
    maxCount: 500,
    delay: 30

});
//attach locale settings
klevu.coreEvent.attach("setRemoteConfigLanding", {
    name: "search-landing-locale",
    fire: function () {
        //get the global translations
        klevu.search.landing.getScope().template.getTranslator().mergeFromGlobal();
        //get the global currency
        klevu.search.landing.getScope().template.getTranslator().getCurrencyObject().mergeFromGlobal();
    }
});
// add templates
klevu.coreEvent.attach("setRemoteConfigLanding", {
    name: "search-landing-templates",
    fire: function () {
        //set templates
        klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateBase"), "klevuTemplateLanding", true);
        klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateNoResultFound"), "noResultFound", true);
        klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplatePagination"), "pagination", true);
        klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateResults"), "results", true);
        klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateProductBlock"), "productBlock", true);
        klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplateProductBlockColor"), "productBlockColor", true);
        klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingTemplatePromoImageBlock"), "promoImageBlock", true);

    }
});
// add chain extensions
klevu.coreEvent.attach("setRemoteConfigLanding", {
    name: "search-landing-chains",
    fire: function () {
		var defaultLimit = getPageSize();
		var DEFAULT_FACET_LIMIT = 50;
		var buildSelectedFilterQuery = function(key, param) {
			return {
				"key": key,
				"settings": {
					"singleSelect": "false"
				},
				"values": decodeURIComponent(param).split(',')
			};
		};

        klevu.search.landing.getScope().chains.request.build.add({
            name: "addProductList",
            fire: function (data, scope) {
                var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);

                var productList = klevu.extend(true, {}, parameterMap.recordQuery);
                var quickStorage = klevu.getSetting(scope.kScope.settings, "settings.storage");

				// checkquery string to build selected filter
				var selectedFilters = [];
				var $landing = document.querySelector('.klevuResultsListingBlock');
				if ($landing && !$landing.classList.contains("is-initialized")) {
					var urlParams = new SearchParams();
					urlParams.forEach(function(param, key) {
						// "q" is handled by "term" setting
						if (!['q', 'page', 'page_size', 'sort'].includes(key)) {
							selectedFilters.push(buildSelectedFilterQuery(key, param));
						}
					});

					// set filter coming from query string
					let target = $landing.querySelector('.klevuLanding');
					if (target) {
						var elScope = target.kElem;
						klevu.setObjectPath(elScope.kScope.data, "localOverrides.query." + 'productList' + ".filters.applyFilters.filters", selectedFilters);
					}
				}

				const page = klevu.getUrlParameter('page');
				if (page) {
					productList.settings.offset = (parseInt(page) - 1) * defaultLimit;
				}

                // setquery type
                productList.id = "productList";
                productList.typeOfRequest = "SEARCH";
                productList.settings.query.term = data.context.term;
                productList.settings.typeOfRecords = ["KLEVU_PRODUCT"];
                productList.settings.searchPrefs = ["searchCompoundsAsAndQuery", "hideOutOfStockProducts"];
                productList.settings.limit = defaultLimit;
                productList.settings.fallbackQueryId = "productListFallback";
                productList.filters.filtersToReturn.enabled = true;
                productList.filters.filtersToReturn.exclude = ["onprescription", "ondiscount", "availableonline", "availableonletter"];
                productList.filters.filtersToReturn.options.limit = DEFAULT_FACET_LIMIT;
                productList.filters.applyFilters.filters = selectedFilters;
                data.request.current.recordQueries.push(productList);
                data.context.doSearch = true;
            }
        });

        klevu.search.landing.getScope().chains.request.build.add({
            name: "addProductListFallback",
            fire: function (data, scope) {
                var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);

                var productListFallback = klevu.extend(true, {}, parameterMap.recordQuery);

                //setquery type
                productListFallback.id = "productListFallback";
                productListFallback.typeOfRequest = "SEARCH";
                productListFallback.isFallbackQuery = "true";
                productListFallback.settings.query.term = "*";
                productListFallback.settings.typeOfRecords = ["KLEVU_PRODUCT"];
                productListFallback.settings.searchPrefs = ["excludeDescription", "searchCompoundsAsAndQuery"];
                productListFallback.settings.limit = 3;
                productListFallback.settings.sort = "RELEVANCE";

                data.request.current.recordQueries.push(productListFallback);

                data.context.doSearch = true;

            }
        });

        /** Event to add pagination */
        klevu.search.landing.getScope().chains.template.events.add({
            name: "addPagination",
            fire: function (data, scope) {
                var target = klevu.getSetting(scope.kScope.settings, "settings.search.searchBoxTarget");
                klevu.each(klevu.dom.find(".klevuPaginate", target), function (key, value) {
                    klevu.event.attach(value, "click", function (event) {
						var $landing = document.querySelector('.klevuResultsListingBlock');
						if ($landing) {
							var searchStartEvent = new CustomEvent('klevuResultsListingBlock.search.start');
							$landing.dispatchEvent(searchStartEvent);
						}

						event = event || window.event;
						event.preventDefault();

						var element = event.target;
						var target = klevu.dom.helpers.getClosest(element, ".klevuTarget");
						if (target === null) {
							return;
						}

						// make sure if user click the link instead of the icon
						if (!element.classList.contains('.klevuPaginate')) {
							element = element.closest('.klevuPaginate');
						}

						var scope = target.kElem;
						scope.kScope.data = scope.kObject.resetData(scope.kElem);
						scope.kScope.data.context.keyCode = 0;
						scope.kScope.data.context.eventObject = event;
						scope.kScope.data.context.event = "keyUp";
						scope.kScope.data.context.preventDefault = false;

						var options = klevu.dom.helpers.getClosest(element, ".klevuMeta");
						// Todo Update template Klevu
						const indexProductList = 0;
						var offset = element.dataset.offset;
						let limit = getLimitPageSize(data.request.original.queryRequest[indexProductList].settings.limit);
						offset = (offset < 0) ? 0 : offset;
						// Add page param into URL.
						const searchParams = new SearchParams();
						const page = parseInt(offset / limit || 0) + 1;
						searchParams.paginate(page).pushState();

						klevu.setObjectPath(scope.kScope.data, "localOverrides.query." + options.dataset.section + ".settings.offset", parseInt(offset));
						klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
					}, true);
				});
			}
		});

		// where to render the responce
		klevu.search.landing.getScope().chains.template.render.add({
			name: "renderResponse",
			fire: function (data, scope) {

				if (data.context.isSuccess) {
					scope.kScope.template.setData(data.template);
					var targetBox = "klevuTemplateLanding";
					var element = scope.kScope.template.convertTemplate(scope.kScope.template.render(targetBox));
					var newElemRefinePanel = element.querySelector('.kuFilters');
					var target = klevu.getSetting(scope.kScope.settings, "settings.search.searchBoxTarget");
					var oldElemRefinePanel = target.querySelector('.kuFilters');
					if(oldElemRefinePanel !== null) {
						if(oldElemRefinePanel.classList.contains('kuFiltersIn')) {
							newElemRefinePanel.classList.add('kuFiltersIn');
						}
					}
					target.innerHTML = '';
					target.classList.add("klevuTarget");
					scope.kScope.element.kData = data.template;
					scope.kScope.template.insertTemplate(target, element);

					var $landing = document.querySelector('.klevuResultsListingBlock');
					if ($landing) {
						var event = new CustomEvent('klevuResultsListingBlock.search.end');
						$landing.dispatchEvent(event);

						if (!$landing.classList.contains('is-initialized')) {
							$landing.classList.add('is-initialized');
						}
					}

					klevu.analyticsUtil.base.registerBannerClickEvent(scope.kScope);
				}
			}
		});

		// update query string on filter changes
		klevu.search.landing.getScope().chains.template.events.add({
			name: "modifyBrowserURL",
			fire: function (data, scope) {
				var selectedFilters = data.localOverrides.query.productList.filters.applyFilters.filters;
				var searchParams = new SearchParams();

				if (selectedFilters && selectedFilters.length > 0) {
					var isModePLP = isPagePLB();
					var ignoreKeys = keyExistQueries();
					selectedFilters.forEach(function(filter, i) {
						if(isModePLP) {
							if (!ignoreKeys.includes(filter.key)) {
								searchParams.set(filter.key, filter.values);
							}
						} else {
							searchParams.set(filter.key, filter.values);
						}
					});
				}

				// Remove param out of filter.
				searchParams.forEach(function(param, key) {
					if (!['q', 'page', 'klevu_price', 'page_size', 'sort'].includes(key)) {
						if (!selectedFilters) {
							searchParams.delete(key);
						} else if (!selectedFilters.find(o => o.key === key)) {
							searchParams.delete(key);
						}
					}
					if (['plu'].includes(key)) {
						searchParams.delete(key);
					}
				}).pushState();
			}
		});

		enablePromoImage() && klevu.search.landing.getScope().chains.response.success.addAfter("checkForSuccess", {
			name: "addPromoImage",
			fire: function (data, scope) {
				const indexProductList = 0;
				let records = data.response.data.queryResults ? data.response.data.queryResults[indexProductList].records : [];
				const hasResults = records.length;
				if (hasResults) addPromoImage(records);
			}
		});

		// Merge staff discount to data search results.
		enableVisitorGroupDiscount() && klevu.search.landing.getScope().chains.request.fetch.send.add({
			name: "sendRequest",
			fire: function (data, scope) {
				if (data.context.eventAction === "searchAjax") return;
				data.scope = scope;
				if (data.context.doSearch) {
					const updateData = (chain, data, requestDetails, status, isSuccess) => {
						chain.setScope(requestDetails.scope.kElem);
						klevu.setObjectPath(requestDetails, "response.data", data);
						klevu.setObjectPath(requestDetails, "context.status", status);
						klevu.setObjectPath(requestDetails, "context.isSuccess", isSuccess);
						chain.setData(requestDetails);
						chain.fire();
					};

					data.context.requestObject = {
						url: data.request.settings.url,
						type: "FETCH",
						method: "POST",
						mimeType: "application/json; charset=UTF-8",
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						crossDomain: true,
						success: function (data, requestDetails, status, isSuccess) {
							const chain = klevu.getObjectPath(requestDetails.scope.kScope, "chains.response.success");
							if (!klevu.isUndefined(chain) && chain.list().length !== 0) {
								const records = data.queryResults[0].records;
								callApi('/api/brisproduct/product-prices/', {
									productCodes: records.map(({productCode}) => productCode),
								}).then((staffDiscount) => {
									staffDiscount.forEach((discount) => {
										const record = records.find((record) => record.productCode === discount.code);
										if (record) {
											klevu.extend(record, discount, {
												isDiscountPrice: (discount.isDiscountPrice || discount.isDiscountPrice === 'True') ? 'true' : 'false',
											});
										}
									});
									updateData(chain, data, requestDetails, status, isSuccess);
								}).catch((e) => {
									updateData(chain, data, requestDetails, status, isSuccess);
								});
							}
						},
						error: function (requestDetails, status, isSuccess) {
							const chain = klevu.getObjectPath(requestDetails.scope.kScope, "chains.response.fail");
							if (!klevu.isUndefined(chain) && chain.list().length !== 0) {
								updateData(chain, {}, requestDetails, status, isSuccess);
							}
						},
						data: JSON.stringify(data.request.settings.object),
					};
					data.context.requestDetails = klevu.extend(true, {}, data);
				}
			},
		});
	},
});

// add template helpers
klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "search-landing-template-helpers",
	fire: function () {
		//add extra helpers
		var quickStorage = klevu.getSetting(klevu.settings, "settings.storage");
		klevu.search.landing.getScope().template.setHelper("cropText", function cropText(textValue, length) {
			if (textValue.length <= length) return textValue;
			return textValue.substring(0, length) + "...";
		});
		klevu.search.landing.getScope().template.setHelper("hasResults", function hasResults(data, name) {
			if (data.query[name]) {
				if (data.query[name].result.length > 0) return true;
			}
			return false;
		});
	}
});

/**
 *  Helper showColor.
 */
klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "product-block-color-template-helpers",
	fire: function () {
		klevu.search.landing.getScope().template.setHelper('showColor', showColor);
	}
});

/**
 *  Helper forEachOption.
 */
klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "product-sort-size-helpers",
	fire: function () {
		klevu.search.landing.getScope().template.setHelper('forEachOption', function ({
			key = "",
			options = []
		}, callBackClearAll, callBack) {
			const values = presetFilterServices().get(key);
			if (key === 'type' && values.length) {
				options = options.filter((item) => values.includes(item.value))
			} else {
				options = options.map((item) => {
					if (values.includes(item.value)) {
						item.customAndQuerySelected = true;
						item.selected = true;
					}

					return item;
				});
			}

			const hasSelected = options.find((item) => item.selected);
			if (hasSelected) {
				callBackClearAll();
			}
			if (key === 'size' && window.SORTED_SIZE_LIST && klevu.isArray(window.SORTED_SIZE_LIST) && window.SORTED_SIZE_LIST.length > 0) {
				const optionObject = {};

				window.SORTED_SIZE_LIST.forEach(fill => {
					optionObject["OPT_" + fill] = {};
				});

				options.forEach(function (option) {
					optionObject["OPT_" + option.value] = option;
				});

				Object.values(optionObject)
					.reduce(function (acc, cur) {
						return klevu.isEmptyObject(cur) ? acc : [...acc, cur];
					}, [])
					.forEach(callBack);
			} else {
				options.forEach(callBack);
			}
		});

		klevu.search.landing.getScope().template.setHelper('isShowMore', function ({
			key = '',
			options = []
		}) {
			const values = presetFilterServices().get(key);
			if (key === 'type' && values.length) {
				options = options.filter((item) => values.includes(item.value))
			}

			return options.length > 5;
		});

		klevu.search.landing.getScope().template.setHelper('getStyle', getStyle);
		klevu.search.landing.getScope().template.setHelper('getDiscountWithClearanceBadgePrefixText', getDiscountWithClearanceBadgePrefixText);
		klevu.search.landing.getScope().template.setHelper('getDisclaimerTextColor', getDisclaimerTextColor);
	}
});

/**
 * Extension for multiselect filter functionality
 */

(function (klevu) {

	/**
	 * Function to initialize muliselect facet item
	 * @param {*} dataOptions
	 */
	function initialize(dataOptions) {
		var list = dataOptions.dataIdList;
		klevu.each(list, function (key, value) {
			var items = klevu.getObjectPath(dataOptions.responseData.template.query, value);
			if (!klevu.isUndefined(items)) {
				klevu.each(items.filters, function (keyFilter, filter) {
					filter.multiselect = false;
					var isKeyFound = dataOptions.multiSelectFilterKeys.find(function (keyName) {
						return keyName == filter.key;
					});
					if (isKeyFound) {
						filter.multiselect = true;
					}
				})
			}
		});
	};

	var multiselectFilters = {
		initialize: initialize
	};

	klevu.extend(true, klevu.search.modules, {
		multiselectFilters: {
			base: multiselectFilters,
			build: true
		}
	});
})(klevu);

/**
 * multiselectFilters module build event
 */
klevu.coreEvent.build({
	name: "multiselectFiltersModuleBuild",
	fire: function () {
		if (!klevu.search.modules ||
			!klevu.search.modules.multiselectFilters ||
			!klevu.search.modules.multiselectFilters.build) {
			return false;
		}
		return true;
	},
	maxCount: 500,
	delay: 30
});

/**
 * Multiselect filters
 */
klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "multiselectFilters",
	fire: function () {

		/**
		 * Attach facet multi select
		 */
		klevu.search.landing.getScope().chains.template.process.success.add({
			name: "addMultiSelectFilters",
			fire: function (data, scope) {

				/** multiselectFilters options  */
				var multiselectFiltersOptions = {
					responseData: data,
					dataIdList: ["productList", "contentCompressed"],
					multiSelectFilterKeys: window.MULTI_SELECT_FILTER_KEYS || []
				};

				klevu.search.modules.multiselectFilters.base.initialize(multiselectFiltersOptions);
			}
		});
	}
});

/**
 * Extension for collapse filter functionality
 */

(function (klevu) {

	/**
	 * Initialize collapsing for filter items
	 */
	function initialize(scope) {
		var target = klevu.getSetting(scope.settings, "settings.search.searchBoxTarget");
		var CLS_SHOW_ALL = "kuFilterShowAll";

		//add collapsable filters
		klevu.each(klevu.dom.find(".kuFilterHead", target), function (key, value) {
			// onclick
			klevu.event.attach(value, "click", function (event) {
				event = event || window.event;
				event.preventDefault();

				this.classList.toggle("kuCollapse");
				this.classList.toggle("kuExpand");

				var parentElem = klevu.dom.helpers.getClosest(this, ".kuFilterBox");
				klevu.each(klevu.dom.find(".kuFilterNames", parentElem), function (key, value) {
					value.classList.toggle("kuFilterCollapse");
					value.classList.remove("kuFilterShowAll");
					var filterItemH = value.querySelectorAll("li:not(.klevuFilterItemClear)")[0].offsetHeight;
					value.style.maxHeight = `${5 * filterItemH}px`; // show top 5
				});
			});
		});
		//add expandable filters
		klevu.each(klevu.dom.find(".kuShowOpt", target), function (key, value) {
			// onclick
			klevu.event.attach(value, "click", function (event) {
				event = event || window.event;
				event.preventDefault();

				var parentElem = klevu.dom.helpers.getClosest(this, ".kuFilterBox");
				var $wrap = parentElem.querySelector(".kuFilterNames");
                var $list = parentElem.querySelector(".kuFilterList");
                var filterItemH = $list.querySelectorAll("li:not(.klevuFilterItemClear)")[0].offsetHeight;

				// check the wrap height and the visible height. then set max-height
				if ($wrap.classList.contains(CLS_SHOW_ALL)) {
					$wrap.classList.remove("kuFilterShowAll"); // show "more" text
					$wrap.style.maxHeight = `${5 * filterItemH}px`; // show top 5
				} else {
					$wrap.style.maxHeight = `unset`;
					$wrap.classList.add("kuFilterShowAll");
                }
			});
		});
	};

	/**
	 * Function to collapse filter list as per the priority list
	 * @param {*} data
	 * @param {*} collapsedFilters
	 */
	function collapse(data, collapsedFilters, itemListId) {
		if (data && data.template && data.template.query && collapsedFilters && collapsedFilters.length) {
			var items = klevu.getObjectPath(data.template.query, itemListId);
			if (items && items.filters) {
				var filters = items.filters;
				filters.forEach(function (filter) {
					filter.isCollapsed = false;
				});
				collapsedFilters.forEach(function (collapsedFilter) {
					filters.forEach(function (filter) {
						if (collapsedFilter.key == filter.key) {
							filter.isCollapsed = true;
						}
					});
				});
			}
		}
	};

	var collapseFilters = {
		collapse: collapse,
		initialize: initialize
	};

	klevu.extend(true, klevu.search.modules, {
		collapseFilters: {
			base: collapseFilters,
			build: true
		}
	});
})(klevu);

/**
 * collapseFilters module build event
 */
klevu.coreEvent.build({
	name: "collapseFiltersModuleBuild",
	fire: function () {
		if (!klevu.search.modules ||
			!klevu.search.modules.collapseFilters ||
			!klevu.search.modules.collapseFilters.build) {
			return false;
		}
		return true;
	},
	maxCount: 500,
	delay: 30
});

/**
 * Collapse filter
 */
klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "collapseFilters",
	fire: function () {

		/**
		 * Function to enable collapsing for filter items
		 */
		klevu.search.landing.getScope().chains.template.events.add({
			name: "enableFilterCollapse",
			fire: function (data, scope) {
				klevu.search.modules.collapseFilters.base.initialize(scope.kScope);
			}
		});

		/**
		 * Function to set filter priority list and reorder filter list
		 */
		klevu.search.landing.getScope().chains.template.render.addBefore("renderResponse", {
			name: "collapseFilterPosition",
			fire: function (data, scope) {
				if (data.context.isSuccess) {

					var collapsedFilters = [{
						key: "tags"
					}, {
						key: "type"
					}, {
						key: "shade_color"
					}, {
						key: "product_type"
					}];

					klevu.search.modules.collapseFilters.base.collapse(data, collapsedFilters, 'productList');
				}
			}
		});
	}
});

/**
 * Attach code event to landing page analytics
 */

klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "attachSearchResultLandingPageAnalyticsEvents",
	fire: function () {

		klevu.search.landing.getScope().chains.template.events.add({
			name: "attachAnalyticsActionEvent",
			fire: function (data, scope) {

				var target = klevu.getSetting(scope.kScope.settings, "settings.search.searchBoxTarget");
				klevu.each(klevu.dom.find(".klevuMeta", target), function (key, value) {
					klevu.event.attach(value, "click", function (event) {
						data.context.section = value.dataset.section;
						scope.kScope.data.context.section = value.dataset.section;
					});
				}, true);

				var tabStorage = klevu.getSetting(scope.kScope.settings, "settings.storage");
				if (tabStorage && tabStorage.tabs) {
					tabStorage.tabs.setStorage("local");
					tabStorage.tabs.mergeFromGlobal();
					var currentSection = tabStorage.tabs.getElement("active");
					if (currentSection && currentSection.length) {
						data.context.section = currentSection;
						scope.kScope.data.context.section = currentSection;
					} else {
						if (klevu.dom.find(".klevuMeta", target)[0]) {
							klevu.dom.find(".klevuMeta", target)[0].click();
						}
					}
				} else {
					if (klevu.dom.find(".klevuMeta", target)[0]) {
						klevu.dom.find(".klevuMeta", target)[0].click();
					}
				}

				var termOptions = klevu.analyticsUtil.base.getTermOptions(scope.kScope, false);
				if (termOptions.klevu_src) {
					termOptions.klevu_src = termOptions.klevu_src.replace("]]", ";;template:landing]]");
					if (termOptions.filters) {
						termOptions.klevu_src = termOptions.klevu_src.replace("]]", ";;source:filters]]");
					}
				}

				delete termOptions.filters;
				klevu.analyticsEvents.term(termOptions);

				klevu.analyticsUtil.base.registerLandingProductClickEvent(
					scope.kScope,
					klevu.analyticsUtil.base.storage.dictionary,
					klevu.analyticsUtil.base.storage.click
				);

			}
		});
	}
});



// WEBPACK FOOTER //
// ./klevu/klevu-landing.js